import {GROUP_TYPE, GROUP_SECTION_WIDTH, CURSOR, getTextColor, drawRectangle, drawExpansionIcon, getTrimmedText, COMMON_IMAGE /*, createCacheCanvas*/} from '../../canvas-timeline/canvas_timeline_util';
import Group from '../../canvas-timeline/canvas_timeline_group';
import {cacheManager} from '../../canvas-timeline/canvas_timeline_cache_manager';
import {interactionManager} from '../../canvas-timeline/canvas_timeline_interaction_manager';
import Util from '../../../../forecast-app/shared/util/util';

class ProjectGroupGroup extends Group {
	constructor(data) {
		super(GROUP_TYPE.PROJECT_SCHEDULING_PROJECT_GROUP, data);
	}
	draw(canvasContext, x, y) {
		const width = GROUP_SECTION_WIDTH;
		const {data, height, expanded, groupType, totalHeight} = this;
		super.draw(x, y, width, height, this);
		const {name, id, color} = data;
		const cacheId = `${groupType}-${id}-${!!expanded}`;

		interactionManager.addCursorStyleArea(x, y, width, height, CURSOR.POINTER, true);

		const drawEncompassingBorder = () => {
			if (!expanded) return;
			drawRectangle(canvasContext, 2, y + height - 1, width - 3, totalHeight - height, {
				backgroundColor: color,
				borderBottomLeftRadius: 10,
			});
		};

		const cachedData = cacheManager.get(groupType, cacheId);
		if (cachedData) {
			canvasContext.drawImage(cachedData, x, y, width, this.itemRowHeight);
			drawEncompassingBorder();
			return;
		}

		const planning = false; // data.status === PROJECT_STATUS.PLANNING;
		//TODO can project group be in planning stage? Is it if all projects are in plannig or any or never???
		const textColor = planning ? '#2a2a2a' : getTextColor(color);

		/*const drawGroup = icon => {
			const cacheCanvas = createCacheCanvas(width, this.itemRowHeight);
			const context = cacheCanvas.getContext('2d');

			//Subtract 1 from width and height to make room for the grey border
			drawRectangle(context, 2, 0, width - 3, height - (expanded ? 0 : 1), {
				backgroundColor: color,
				backgroundOpacity: planning ? 0.3 : 1,
				borderColor: color,
				borderThickness: planning ? 2 : 0,
				borderTopLeftRadius: 10,
				borderBottomLeftRadius: expanded ? 0 : 10
			});
			drawExpansionIcon(context, 0, 0, width, height, {
				backgroundColor: planning ? undefined : color,
				expanded
			});
			context.fillStyle = textColor;
			context.font = '700 10px ' + Util.getFontFamily();
			context.fillText(`X${data.companyProjectGroupId}`, 16, 24);
			context.font = '500 12px ' + Util.getFontFamily();
			const formattedProjectName = getTrimmedText(context, name);
			context.fillText(formattedProjectName, 70, 25);
			if (icon) {
				context.drawImage(icon, 52, 13, 14, 14);
			}
			cacheManager.set(groupType, cacheId, cacheCanvas);
			canvasContext.drawImage(cacheCanvas, x, y, width, this.itemRowHeight);
		};*/
		const drawGroup = icon => {
			//Subtract 1 from width and height to make room for the grey border
			drawRectangle(canvasContext, x + 2, y + 0, width - 3, height - (expanded ? 0 : 1), {
				backgroundColor: color,
				backgroundOpacity: planning ? 0.3 : 1,
				borderColor: color,
				borderThickness: planning ? 2 : 0,
				borderTopLeftRadius: 10,
				borderBottomLeftRadius: expanded ? 0 : 10,
			});
			drawExpansionIcon(canvasContext, x, y, width, height, {
				backgroundColor: planning ? undefined : color,
				expanded,
			});
			canvasContext.fillStyle = textColor;
			canvasContext.font = '700 10px ' + Util.getFontFamily();
			canvasContext.fillText(`X${data.companyProjectGroupId}`, x + 16, y + 24);
			canvasContext.font = '500 12px ' + Util.getFontFamily();
			const formattedProjectName = getTrimmedText(canvasContext, name);
			canvasContext.fillText(formattedProjectName, x + 70, y + 25);
			if (icon) {
				canvasContext.drawImage(icon, x + 52, y + 13, 14, 14);
			}
		};
		drawGroup(cacheManager.getCommonImage(COMMON_IMAGE[textColor === '#ffffff' ? 'CONNECTED_PROJECT_WHITE' : 'CONNECTED_PROJECT_BLACK']));
		drawEncompassingBorder();
	}
}
export default ProjectGroupGroup;
